import { Breadcrumb, Select, Input, Space } from "antd";
import { t } from "i18next";
import { BackIcon, DotHour } from "../../../../asset";
import React, { useState } from "react";
import style from "./deliveryTypePage.module.css";
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { useDeliveryType } from "./DeliveryTypePage.hooks";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import { useLocation } from "react-router-dom";
import CustomToogle from "../../../../component/toogle/CustomToogle";

export default function DeliveryTypeAdd() {
  const { state } = useLocation();

  const {
    doPostDeliveryType,
    deliveryTypeDescriptionError,
    deliveryTypeError,
    successModalOpen,
    toListDeliveryType,
    deliveryType,
    onChange,
    isClear,
    setShowConfirm,
    showConfirm,
    failedModalOpen,
    messageFailed,
    setFailedModalOpen,
    form,
    error,
    handleChangeTime,
    handleBlur,
    operationalDate,
    operational_start_time,
    handleToogle,
    handleSupportMitraGro,
    isSupportMitraGro
  } = useDeliveryType();

  //   const handleToogle = (d, i) => {
  //     const newDetail = [...operationalDate];
  //     newDetail[i]["is_operational_active"] = d === "Y" ? "N" : "Y";
  //     if (d === "Y") {
  //       newDetail[i]["operational_start_time"] = "00:00"
  //       newDetail[i]["operational_end_time"] = "00:00"
  //     }
  //     setOperationalDate(newDetail)
  //   };
  return (
    <div className="p-[24px] flex flex-col gap-[24px]">
      <NotifFailedSaved
        visible={failedModalOpen}
        message={
          "Data with this Delivery Type is already used by other, cant process this action"
        }
        action={() => {
          setFailedModalOpen(false);
        }}
      />
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.DELIVERY_TYPE.LIST}
      />

      <SuccessModal
        isOpen={successModalOpen}
        onOk={() => toListDeliveryType()}
        closable={false}
        width={280}
        className={style.successModal}
        okText="Ok"
        title="Success"
        description={
          <p>
            <strong>New Delivery Type {deliveryType}</strong> has been added
          </p>
        }
      />

      <Breadcumbs
        jmlLevel={4}
        menuLevel1={`Master`}
        menuLevel2={`Fleet`}
        menuLevel3={`Delivery Type`}
        menuLevel4={`Add Delivery Type`}
      />

      <div
        className="flex items-center gap-[22px]"
        onClick={
          !isClear() ? () => setShowConfirm(true) : () => toListDeliveryType()
        }
      >
        <img src={BackIcon} className="cursor-pointer" alt="back-icon" />
        <h1 className="font-sans-bold text-2xl cursor-pointer" id="title">
          {t("DELIVERY_TYPE_ADD:TITLE")}
        </h1>
      </div>

      <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px]">
        {/* <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("DELIVERY_TYPE_ADD:DELIVERY_TYPE_INFORMATION")}</h3>

                <div className="flex flex-col gap-[16px]">
                <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("Delivery Type Code")}</label>
                        <Input style={{ width: 350 }} className={`mt-[8px] ${deliveryTypeError ? `border-[1px] border-[#FF0000]` : ''}`} 
                            maxLength={256} 
                            size="large"
                            onChange={(event) => {onChange(event, 'delivery_type_code')}}
                            placeholder={t("DELIVERY_TYPE_ADD:DELIVERY_TYPE_PLACEHOLDER")} 
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${deliveryTypeError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_ADD:DELIVERY_TYPE_FIELD")}</label>
                        <Input style={{ width: 350 }} className={`mt-[8px] ${deliveryTypeError ? `border-[1px] border-[#FF0000]` : ''}`} 
                            maxLength={256} 
                            size="large"
                            onChange={(event) => {onChange(event, 'delivery_type')}}
                            placeholder={t("DELIVERY_TYPE_ADD:DELIVERY_TYPE_PLACEHOLDER")} 
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${deliveryTypeError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                    <div className="flex flex-col">
                        <label className="font-roboto font-medium text-[16px] text-md">{t("DELIVERY_TYPE_ADD:DESRIPTION_FIELD")}</label>
                        <TextArea
                            style={deliveryTypeDescriptionError ? { width: 350, resize: 'none', borderColor: `#FF0000`, borderWidth: 1 } : { width: 350, resize: 'none' }}
                            placeholder={t("DELIVERY_TYPE_ADD:DESCRIPTION_PLACEHOLDER")}
                            onChange={(event) => {onChange(event, 'description')}}
                            maxLength={256}
                        />
                        <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${deliveryTypeDescriptionError ? `visible` : `hidden`}`}>This field is required</p>
                    </div>
                </div> */}
        <div className="flex">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Delivery Type Information")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="flex flex-col">
                  <label className="font-roboto font-medium text-[16px] text-md">
                    {t("Support MitraGro")}
                  </label>
                  <div className="flex w-[160px] h-[70px]">
                    <div className="mr-[8px]">
                    <CustomToogle
                          namespace={"tglsetallaccess"}
                          // checked={
                          //   d?.is_operational_active === "Y" ? true : false
                          // }
                          checked={isSupportMitraGro}
                          handleChange={(event) =>
                            handleSupportMitraGro(event)
                          }
                        />
                    </div>
                        <div className="font-roboto mt-2 text-[#424242] text-[16px] text-lg">{isSupportMitraGro ? "Support": "Not Support"}</div>
                        
                        {/* {d?.is_operational_active === "Y" ? "Open" : "Close"} */}
                      </div>
                  {/* <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${error?.delivery_code ? `visible` : `hidden`}`}>This field is required</p> */}
                </div>
                <div className="flex flex-col mb-[24px]">
                  <label className="font-roboto font-medium text-[16px] text-md">
                    {t("Delivery Type Code")}
                  </label>
                  <Input
                    style={{ width: 350 }}
                    className={`mt-[8px] ${
                      error?.delivery_code
                        ? `border-[1px] border-[#FF0000]`
                        : ""
                    }`}
                    maxLength={256}
                    size="large"
                    onChange={(event) => {
                      onChange(event, "delivery_code");
                    }}
                    placeholder={t(
                      "DELIVERY_TYPE_ADD:DELIVERY_TYPE_PLACEHOLDER"
                    )}
                  />
                  <p
                    className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${
                      error?.delivery_code ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>
                <div className="flex flex-col mb-[24px]">
                  <label className="font-roboto font-medium text-[16px] text-md">
                    {t("DELIVERY_TYPE_ADD:DELIVERY_TYPE_FIELD")}
                  </label>
                  <Input
                    style={{ width: 350 }}
                    className={`mt-[8px] ${
                      error?.delivery_type
                        ? `border-[1px] border-[#FF0000]`
                        : ""
                    }`}
                    maxLength={256}
                    size="large"
                    onChange={(event) => {
                      onChange(event, "delivery_type");
                    }}
                    placeholder={t(
                      "DELIVERY_TYPE_ADD:DELIVERY_TYPE_PLACEHOLDER"
                    )}
                  />
                  <p
                    className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${
                      error?.delivery_type ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>
                <div className="flex flex-col mb-[24px]">
                  <label className="font-roboto font-medium text-[16px] text-md">
                    {t("DELIVERY_TYPE_ADD:DESRIPTION_FIELD")}
                  </label>
                  <TextArea
                    style={
                      error?.description
                        ? {
                            width: 350,
                            resize: "none",
                            borderColor: `#FF0000`,
                            borderWidth: 1,
                          }
                        : { width: 350, resize: "none" }
                    }
                    placeholder={t("DELIVERY_TYPE_ADD:DESCRIPTION_PLACEHOLDER")}
                    onChange={(event) => {
                      onChange(event, "description");
                    }}
                    maxLength={256}
                  />
                  <p
                    className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${
                      error?.description ? `visible` : `hidden`
                    }`}
                  >
                    This field is required
                  </p>
                </div>

                {operationalDate.map((d, i) => (
                  <>
                    <div className="flex w-[680px] font-medium font-roboto text-base">
                      <div className="w-[160px] h-[25px]">Start Trip</div>
                      {d?.is_operational_active === "Y" ? (
                        <>
                          <div className="w-[160px]">Start Automatic at</div>
                          {/* <div className="w-[40%]"></div> */}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="flex w-[680px]">
                    <div className="flex w-[180px] h-[70px]">
                    <div className="mr-[8px]">
                        <CustomToogle
                          namespace={"tglsetallaccess"}
                          checked={
                            d?.is_operational_active === "Y" ? true : false
                          }
                          handleChange={() =>
                            handleToogle(d?.is_operational_active, i)
                          }
                        />
                        </div>
                        <div className="font-roboto mt-2 text-[#424242] text-[16px] text-lg">
                        
                        {d?.is_operational_active === "Y" ? "Open" : "Close"}
                        </div>
                      </div>
                      {d?.is_operational_active === "Y" ? (
                        <>
                          <div className="w-[160px]">
                            <div className="flex w-[500px]">
                              <Input
                                className="mt-[8px] h-[47px] w-[55px] mr-2"
                                onChange={(value) =>
                                  handleChangeTime(
                                    value,
                                    "operational_start_time",
                                    0,
                                    i
                                  )
                                }
                                onBlur={() =>
                                  handleBlur(
                                    operationalDate[i]?.[
                                      "operational_start_time"
                                    ].split(":")[0],
                                    "operational_start_time",
                                    0,
                                    i
                                  )
                                }
                                // status={error?.shift_start_hour ? "error" : ""}
                                value={d?.operational_start_time.split(":")[0]}
                              />

                              <div className="text-red-100">
                                {/* {error?.shift_start_hour} */}
                              </div>
                              <img src={DotHour} alt="hour" />
                              <Input
                                className="mt-[8px] h-[47px] w-[55px] ml-2"
                                onChange={(value) =>
                                  handleChangeTime(
                                    value,
                                    "operational_start_time",
                                    1,
                                    i
                                  )
                                }
                                onBlur={() =>
                                  handleBlur(
                                    operationalDate[i]?.[
                                      "operational_start_time"
                                    ].split(":")[1],
                                    "operational_start_time",
                                    1,
                                    i
                                  )
                                }
                                // status={error?.shift_start_min ? "error" : ""}
                                value={d?.operational_start_time.split(":")[1]}
                              />
                              {/* <div className="ml-5">
                      <img src={HourAM} alt="am" />
                    </div> */}
                              {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                            </div>
                          </div>
                          {/* <div className="ml-5">
                      <img src={HourPM} alt="pm" />
                    </div> */}
                          {/* <div className="text-red-100">{error?.shift_start_min}</div> */}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                ))}
              </div>

              {/* LINE TWO */}
              <div className="gap-[40px] mb-[24px] mt-[-50px]">
                <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                  {t("Cost Information")}
                </h3>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Cost/Kg")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="Rp"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => onChange(value, "price_weight")}
                      status={error?.price_weight ? "error" : ""}
                      value={form?.price_weight}
                      placeholder="5.000.000"
                    />
                  </Space.Compact>
                  <div className="text-red-100">{error?.price_weight}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Cost/m")}<sup>3</sup>
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="Rp"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => onChange(value, "price_volume")}
                      status={error?.price_volume ? "error" : ""}
                      value={form?.price_volume}
                      placeholder="5.000.000"
                    />
                  </Space.Compact>
                  <div className="text-red-100">{error?.price_volume}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Cost/Km")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="Rp"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => onChange(value, "price_distance")}
                      status={error?.price_distance ? "error" : ""}
                      value={form?.price_distance}
                      placeholder="5.000.000"
                    />
                  </Space.Compact>
                  <div className="text-red-100">{error?.price_distance}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Cost/hours")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="Rp"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => onChange(value, "price_time")}
                      status={error?.price_time ? "error" : ""}
                      value={form?.price_time}
                      placeholder="5.000.000"
                    />
                  </Space.Compact>
                  <div className="text-red-100">{error?.price_time}</div>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Base Price")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%" }}
                      defaultValue="Rp"
                      disabled
                    />
                    <Input
                      style={{ width: "480px", height: "47px" }}
                      onChange={(value) => onChange(value, "base_price")}
                      status={error?.base_price ? "error" : ""}
                      value={form?.base_price}
                      placeholder="5.000.000"
                    />
                  </Space.Compact>
                  <div className="text-red-100">{error?.base_price}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row-reverse justify-start gap-[16px]">
        <button
          className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]"
          onClick={() => doPostDeliveryType(state.depotId)}
        >
          {t("DELIVERY_TYPE_ADD:ADD_BUTTON")}
        </button>
        <button
          className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]"
          onClick={
            !isClear() ? () => setShowConfirm(true) : () => toListDeliveryType()
          }
        >
          {t("DELIVERY_TYPE_ADD:CANCEL_BUTTON")}
        </button>
      </div>
    </div>
  );
}
